/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderDirectoryContact } from './ProviderDirectoryContact';
import {
    ProviderDirectoryContactFromJSON,
    ProviderDirectoryContactFromJSONTyped,
    ProviderDirectoryContactToJSON,
} from './ProviderDirectoryContact';

/**
 * 
 * @export
 * @interface CreateDirectoryContact201Response
 */
export interface CreateDirectoryContact201Response {
    /**
     * 
     * @type {ProviderDirectoryContact}
     * @memberof CreateDirectoryContact201Response
     */
    data?: ProviderDirectoryContact;
}

/**
 * Check if a given object implements the CreateDirectoryContact201Response interface.
 */
export function instanceOfCreateDirectoryContact201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDirectoryContact201ResponseFromJSON(json: any): CreateDirectoryContact201Response {
    return CreateDirectoryContact201ResponseFromJSONTyped(json, false);
}

export function CreateDirectoryContact201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDirectoryContact201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ProviderDirectoryContactFromJSON(json['data']),
    };
}

export function CreateDirectoryContact201ResponseToJSON(value?: CreateDirectoryContact201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ProviderDirectoryContactToJSON(value.data),
    };
}

